import ajax from "../assets/uilt/ajax";

let alertCEMTIF = {
  /**根据ID查询申请记录 */
  getById: (req) => {
    return ajax.get({
      url: "/back/CEMTIF/get-by-id",
      param: req.param,
      success: req.success,
    });
  },
  /**分页查询申请记录 */
  getPage: (req) => {
    return ajax.get({
      url: "/back/CEMTIF/get-page",
      param: req.param,
      success: req.success,
    });
  },

  /**增加申请记录(渠道充值、提现) */
  addAlertCEMTIFApply: (req) => {
    return ajax.post({
      url: "/back/CEMTIF/add-alertCEMTIFApply",
      param: req.param,
      success: req.success,
    });
  },
  /**审核渠道充值、提现 */
  disposeAlertCEMTIFApply: (req) => {
    return ajax.post({
      url: "/back/CEMTIF/dispose-alertCEMTIFApply",
      param: req.param,
      success: req.success,
    });
  },
};

export default alertCEMTIF;
